module.exports = __webpack_public_path__ + "img/rune-regeneration.94631ed5.png";